import Discuss from './Discuss'
import DiscussContianer from './DiscussContainer'

export default DiscussContianer(Discuss)
